<template>
  <div class="content-main">
    <van-loading v-if="loading" class="loading" size="24px" vertical>加载中...</van-loading>

    <div class="records" v-if="!loading">
      <div class="names-list flex-box">
        <div class="record" v-for="name in names" :key="name" @click="goMessageCheckSpecific(name)">
          {{name}}
        </div>
      </div>
      <div class="no-more" v-if="names.length > 0">没有更多了～</div>
      <div class="no-more" v-if="names.length == 0">你还没有添加特别关注～</div>
    </div>

  </div>
</template>

<script>
// import wx from 'weixin-js-sdk'
import { Toast, Dialog, Loading} from 'vant'

export default{
  data(){
    return {
      openid: '',
      names: [],
      loading: true
    }
  },
  methods: {
    handleRouter(path){
      this.$router.push(path)
    },
    getFocusRecord(){
      let openid = this.$store.state.userinfo.openid
      this.$api.get('/garden/get_special_focus_names', {openid: openid}, res => {
        if(res.code == 200){
          this.loading = false
          this.names = res.names
        }
      })
    },
    goMessageCheckSpecific(receiver){
      this.$router.replace("/message_check?receiver=" + receiver)
    }
  },
  mounted(){
    this.getFocusRecord()
  }
}
</script>

<style scoped>
.content-main{
  min-height:100vh;
  background-color: #f8f8f8;
  padding:10px;
}
.loading{margin-top:30%;}
.records .names-list{flex-wrap: wrap;}
.records .record{
  background: #fff;
  margin-top: 20px;
  box-shadow: 0 5px 8px 0 rgb(51 51 51 / 5%);
  border-radius: 8px;
  padding:4px 15px;
  border:1px solid #f1b8af;
  font-size:13px;
  color:#666;
  margin-right:10px;
}
.records .no-more{font-size:14px;color:#8590a6;text-align:center;margin-top:20px;}
</style>
